import React from 'react';
import PropTypes from 'prop-types';
import {
  MenuItem as MenuItemComponent, MenuItemAction, MenuItemText, IconButton,
} from '@picsio/ui';
import { Trash } from '@picsio/ui/dist/icons';

const MenuItem = (props) => {
  const {
    value,
    text,
    onRemove,
    option,
    ...rest
  } = props;
  const isDefaultPreset = !!option?.isDefault;
  const isAllowRemove = value !== 'original'
    && value !== 'custom'
    && !option?.data?.resolution
    && !option?.data?.usePdfProxy
    && !isDefaultPreset;

  return (
    <MenuItemComponent variant="select" ellipsis {...rest}>
      <MenuItemText primary={text} />
      <If condition={isAllowRemove}>
        <MenuItemAction>
          <IconButton
            color="inherit"
            buttonSize="lg"
            onClick={(e) => {
              e.stopPropagation();
              onRemove(value, text);
            }}
          >
            <Trash />
          </IconButton>
        </MenuItemAction>
      </If>
    </MenuItemComponent>
  );
};

MenuItem.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  option: PropTypes.object,
};

MenuItem.defaultProps = {
  option: { data: {} },
};

export default MenuItem;
